module.exports = __webpack_public_path__ + "static/Gremlinz_back_small1.2fe55225.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Gremlinz/Gremlinz_back_small1.jpg
// module id = 1694
// module chunks = 249972491463148